import Vue from 'vue'
import VueRouter from 'vue-router'
import NavBar from '../components/NavBar.vue'
import Layout from '../views/layout/layout'
import Login from '../views/login/login'
import serviceGuide from '../views/serviceGuide/index.vue'
import jzxz from '../views/serviceGuide/jzxz.vue'
import mzjzlc from '../views/serviceGuide/mzjzlc.vue'
import zylc from '../views/serviceGuide/zylc.vue'
import jszlcjpdlc from '../views/serviceGuide/jszlcjpdlc.vue'
import zzjsbmztdxmbllc from '../views/serviceGuide/zzjsbmztdxmbllc.vue'
import bafylc from '../views/serviceGuide/bafylc.vue'

import patient from './patient'
import baogao from './baogao'
import guahao from './guahao'
import hospital from './hospital'
import yujianfenzhen from './yujianfenzhen'
import hospitalization from './hospitalization'

Vue.use(VueRouter)

const routes = [
  // 主页
  {
    path: '/',
    name: 'layout',
    meta: { title: '首页' },
    component: Layout

  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: Login
  },
  {
    path: '/serviceGuide',
    name: 'serviceGuide',
    meta: { title: '门诊服务指南' },
    component: serviceGuide
  },
  {
    path: '/jzxz',
    name: 'jzxz',
    meta: { title: '就诊须知' },
    component: jzxz
  },
  {
    path: '/mzjzlc',
    name: 'mzjzlc',
    meta: { title: '门诊就诊流程' },
    component: mzjzlc
  },
  {
    path: '/zylc',
    name: 'zylc',
    meta: { title: '住院流程' },
    component: zylc
  },
  {
    path: '/zzjsbmztdxmbllc',
    name: 'zzjsbmztdxmbllc',
    meta: { title: '重症精神病门诊特定项目办理流程' },
    component: zzjsbmztdxmbllc
  },
  {
    path: '/jszlcjpdlc',
    name: 'jszlcjpdlc',
    meta: { title: '精神智力残疾评定流程' },
    component: jszlcjpdlc
  },
  {
    path: '/bafylc',
    name: 'bafylc',
    meta: { title: '病案复印流程' },
    component: bafylc
  },
  {
    path: '/',
    redirect: '/layout',
    component: NavBar,
    children: [
      ...patient,
      ...baogao,
      ...guahao,
      ...hospital,
      ...yujianfenzhen,
      ...hospitalization,
      {
        path: '/menzhenjiaofei',
        name: 'menzhenjiaofei',
        meta: { title: '门诊缴费' },
        component: () => import(/* webpackChunkName: "about" */ '../views/menzhenjiaofei/menzhenjiaofei')
      },
      {
        path: '/menzhenjiaofeijilu',
        name: 'menzhenjiaofeijilu',
        meta: { title: '门诊缴费记录' },
        component: () => import(/* webpackChunkName: "about" */ '../views/menzhenjiaofeijilu/menzhenjiaofeijilu')
      },
      {
        path: '/jiaofeimingxi',
        name: 'jiaofeimingxi',
        meta: { title: '缴费明细' },
        component: () => import(/* webpackChunkName: "about" */ '../views/jiaofeimingxi/jiaofeimingxi')
      },
      {
        path: '/myline',
        name: 'myline',
        meta: { title: '我的排队' },
        component: () => import(/* webpackChunkName: "about" */ '../views/myLine/myLine')
      },
      {
        path: '/keshijieshao',
        name: 'keshijieshao',
        meta: { title: '科室介绍' },
        component: () => import(/* webpackChunkName: "about" */ '../views/keshijieshao/keshijieshao')
      },
      {
        path: '/yishengjieshao',
        name: 'yishengjieshao',
        meta: { title: '医生介绍' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yishengjieshao/yishengjieshao')
      },
      {
        path: '/yishengDetails',
        name: 'yishengDetails',
        meta: { title: '医生介绍详情' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yishengjieshao/yishengDetails')
      },
      {
        path: '/loucengfenbu',
        name: 'loucengfenbu',
        meta: { title: '楼层分布' },
        component: () => import(/* webpackChunkName: "about" */ '../views/loucengfenbu/loucengfenbu')
      },
      {
        path: '/yujianfenzhen',
        name: 'yujianfenzhen',
        meta: { title: '预检分诊' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yujianfenzhen/yujianfenzhen')
      },
      {
        path: '/yujianfenzhenForm',
        name: 'yujianfenzhenForm',
        meta: { title: '预检分诊表填写' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yujianfenzhen/components/yujianfenzhenForm')
      },
      {
        path: '/yujianfenzhenFormGh',
        name: 'yujianfenzhenFormGh',
        meta: { title: '预检分诊表填写' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yujianfenzhenGh/yujianfenzhenForm')
      },
      {
        path: '/yujianfenzhenList',
        name: 'yujianfenzhenList',
        meta: { title: '预检分诊表列表' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yujianfenzhenList/yujianfenzhenList')
      },
      {
        path: '/yujianfenzhenUser',
        name: 'yujianfenzhenUser',
        meta: { title: '预检分诊表列表' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yujianfenzhen/yujianfenzhenUser')
      },
      {
        path: '/originModule',
        name: 'originModule',
        meta: { title: '关怀模式' },
        component: () => import(/* webpackChunkName: "about" */ '../views/layout/originModule.vue')
      },
      {
        path: '/noFunction',
        name: 'noFunction',
        meta: { title: '暂不开放' },
        component: () => import(/* webpackChunkName: "about" */ '../views/layout/noFunction.vue')
      },
      {
        path: '/yunchanxinshen',
        name: 'yunchanxinshen',
        meta: { title: '孕产心身问卷' },
        component: () => import(/* webpackChunkName: "about" */ '../views/yunchanxinshen/yunchanxinshen')
      }
      // {
      //   path: '/patientLiuyan',
      //   name: 'patientLiuyan',
      //   meta: { title: '患者留言' },
      //   component: () => import(/* webpackChunkName: "about" */ '../views/patientLiuyan/index')
      // }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
